module.exports = __webpack_public_path__ + "static/media/Exo-Light.551934c9.ttf";